<h2>Update Entities Processing State<mat-icon class="drag-handle">drag_indicator</mat-icon></h2>
<ng-container *ngIf="errors$ | async as errors">
  <div class="command-error-message">
    Errors found:
    <ul>
      <li *ngFor="let error of errors">
        {{ error.message }}
      </li>
    </ul>
  </div>
</ng-container>
<div fxLayout="column" fxLayoutGap="10px">
  <mat-form-field>
    <mat-select placeholder="From" [formControl]="fromStatesCtrl" multiple required>
      <mat-option *ngFor="let option of fromOptions" [value]="option">
        {{ option | humanize }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-select placeholder="To" [formControl]="toStateCtrl" required>
      <mat-option *ngFor="let option of toOptions" [value]="option">
        {{ option | humanize }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div fxLayout fxLayoutGap="10px">
  <button
    mat-raised-button
    (click)="submit()"
    [disabled]="!fromStatesCtrl.valid || !toStateCtrl.valid"
  >
    Update Records
  </button>
  <a mat-button [mat-dialog-close]="true">Cancel</a>
</div>
